import {
  emptyTransactionsSection,
  fetchTransactionsFilters,
  setTransactionsKiosk,
  setTransactionsTickets,
  setTransactionsView,
} from "@actions";
import { setTransactionsLiability } from "@actions/transactions";
import kiosk from "@api/kiosk";
import transactions from "@api/transactions";
import DownloadButton from "@buttons/DownloadButton";
import OrgTreeButton from "@buttons/OrgTreeButton";
import SummaryButton from "@buttons/SummaryButton";
import KioskTab from "@components/transactions/KioskTab";
import LiabilityTab from "@components/transactions/LiabilityTab";
import TicketsFilters from "@components/transactions/TicketsFilters";
import TicketsTab from "@components/transactions/TicketsTab";
import TransactionFilters from "@components/transactions/TransactionFilters";
import UserInput from "@components/transactions/UserInput";
import { handleDownload } from "@helpers/downloads";
import { getControlValues } from "@helpers/summary";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { Form, Grid, Menu, Tab } from "semantic-ui-react";

class TransactionsView extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.filters.filterSelected.operator !==
        prevProps.filters.filterSelected.operator ||
      this.props.filters.filterSelected.site.id !==
        prevProps.filters.filterSelected.site.id
    ) {
      this.loadPeriods();

      const panes = this.getPanes();
      panes.forEach((_, index) => this.loadSummary(index));
    }
  }

  onPageChange = (activePage) => {
    const { activeIndex } = this.props.view;
    const { fnDispatch, reduxKey } = this.getPanes()[activeIndex];
    const { grid } = this.props[reduxKey];
    fnDispatch({ grid: { ...grid, pageNumber: activePage } }).then(() => {
      this.handleRefresh(activeIndex);
    });
  };

  getPanes = () => {
    const { hasSelection } = this.props.filters;
    const { searchParams } = this.props.view;
    const { username } = searchParams;
    return [
      {
        key: "Kiosk/Cash Desk",
        menuItem: (
          <Menu.Item disabled={!hasSelection}>Kiosk/Cash Desk</Menu.Item>
        ),
        fnSummary: transactions.getKioskSummary,
        fnRefresh: transactions.getKiosk,
        fnDispatch: this.props.setTransactionsKiosk,
        fnExport: transactions.getKioskExport,
        reduxKey: "kiosk",
        pane: (
          <Tab.Pane>
            <KioskTab
              prefix={
                <Form>
                  <UserInput
                    value={username}
                    name="username"
                    onChange={(name, value) =>
                      this.props.setTransactionsView({
                        searchParams: { ...searchParams, [name]: value },
                      })
                    }
                    disabled={!hasSelection || this.props.kiosk.loading}
                  />
                </Form>
              }
              onPageChange={this.onPageChange}
              onOptionChange={this.onOptionChange}
            />
          </Tab.Pane>
        ),
      },
      {
        key: "Tickets",
        menuItem: <Menu.Item disabled={!hasSelection}>Tickets</Menu.Item>,
        fnSummary: transactions.getTicketsSummary,
        fnRefresh: transactions.getTickets,
        fnDispatch: this.props.setTransactionsTickets,
        fnExport: transactions.getTicketsExport,
        reduxKey: "tickets",
        pane: (
          <Tab.Pane>
            <TicketsTab
              prefix={<TicketsFilters onRefresh={this.onRefresh} />}
              onPageChange={this.onPageChange}
              onOptionChange={this.onOptionChange}
            />
          </Tab.Pane>
        ),
      },
      {
        key: "Site Liability",
        menuItem: (
          <Menu.Item disabled={!hasSelection}>Site Liability</Menu.Item>
        ),
        fnSummary: transactions.getLiabilitySummary,
        fnRefresh: transactions.getLiability,
        fnExport: transactions.getLiabilityExport,
        fnDispatch: this.props.setTransactionsLiability,
        reduxKey: "liability",
        pane: (
          <Tab.Pane>
            <LiabilityTab
              onPageChange={this.onPageChange}
              onOptionChange={this.onOptionChange}
            />
          </Tab.Pane>
        ),
      },
    ];
  };

  componentWillUnmount() {
    this.props.emptyTransactionsSection();
  }

  loadSummary = (activeIndex) => {
    const { useCollectionWeek } = this.props.view;
    const { reduxKey, fnDispatch, fnSummary } = this.getPanes()[activeIndex];
    const defaultGrid = { data: [], headerDef: [], rowDef: [] };
    fnDispatch({ grid: defaultGrid, loading: true }).then(() => {
      const { filterSelected, filterData } = this.props.filters;
      const details = getControlValues(this.props[reduxKey].summary.data);
      const { searchParams } = this.props.view;
      if (!this.props.filters.hasSelection) {
        fnDispatch({ loading: false });
        return;
      }
      fnSummary(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        details,
      ).then(
        (summary) =>
          fnDispatch({ summary, loading: false }).then(() =>
            this.handleRefresh(activeIndex),
          ),
        (error) => fnDispatch({ loading: false }),
      );
    });
  };

  handleRefresh = (activeIndex) => {
    const { reduxKey, fnDispatch, fnRefresh } = this.getPanes()[activeIndex];
    const callback = () => {
      const { filterSelected, filterData } = this.props.filters;
      const { searchParams, useCollectionWeek } = this.props.view;

      fnDispatch({ loading: true }).then(() => {
        const details = getControlValues(this.props[reduxKey].summary.data);
        fnRefresh(
          useCollectionWeek,
          searchParams,
          filterSelected,
          filterData,
          details,
          this.props[reduxKey].grid.pageNumber,
        ).then(
          (grid) => {
            this.props.setTransactionsView({ showSummary: true });
            fnDispatch({ loading: false, grid });
          },
          (error) => {
            fnDispatch({ loading: false });
          },
        );
      });
    };

    if (this.props.useCurrentDateTime) {
      this.props.onChange("endDate", moment().toISOString(true), callback);
    } else {
      callback();
    }
  };

  onRefresh = () => this.loadSummary(this.props.view.activeIndex);

  loadPeriods = () => {
    const { operator } = this.props.filters.filterSelected;
    const siteId = this.props.filters.filterSelected.site.id;
    const companyId = this.props.filters.filterSelected.company.id;
    const subCompanyId = this.props.filters.filterSelected.subcompany.id;
    this.props
      .setTransactionsView({
        periods: [],
      })
      .then(() => {
        this.props.setTransactionsView({ loading: false }).then(() => {
          if (siteId) {
            this.props.setTransactionsView({ loading: true }).then(() => {
              kiosk
                .Positions(
                  operator,
                  companyId,
                  subCompanyId,
                  siteId,
                  true,
                  true,
                  true,
                  true,
                  true,
                )
                .then(({ collectionDates }) => {
                  const defaultPeriod =
                    Array.isArray(collectionDates) && collectionDates.length > 1
                      ? collectionDates[0].id
                      : null;
                  this.props.setTransactionsView({
                    periods: collectionDates,
                    searchParams: {
                      ...this.props.view.searchParams,
                      week: defaultPeriod,
                      loading: false,
                    },
                  });
                });
            });
          }
        });
      });
  };

  loadExport = () => {
    const { activeIndex } = this.props.view;
    const { fnExport, reduxKey } = this.getPanes()[activeIndex];
    const { filterSelected, filterData } = this.props.filters;
    const details = getControlValues(this.props[reduxKey].summary.data);
    const { searchParams, useCollectionWeek } = this.props.view;

    this.props.setTransactionsView({ exportLoading: true }).then(() => {
      fnExport(
        useCollectionWeek,
        searchParams,
        filterSelected,
        filterData,
        details,
      ).then(
        (response) =>
          this.props
            .setTransactionsView({ exportLoading: false })
            .then(() => handleDownload(response)),
        () => this.props.setTransactionsView({ exportLoading: false }),
      );
    });
  };

  onOptionChange = (summary) => {
    const { activeIndex } = this.props.view;
    const { fnDispatch } = this.getPanes()[activeIndex];
    fnDispatch({ summary });
  };

  onTabChange = (e, { activeIndex }) =>
    this.props.setTransactionsView({ activeIndex });

  render() {
    const { exportLoading, showSummary } = this.props.view;
    const { hasSelection, showOrgTree } = this.props.filters;
    const panes = this.getPanes();
    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column>
            <div className="flex-vertical" style={{ marginTop: "4px" }}>
              <div className="flex-shrink" style={{ width: "39px" }}>
                <OrgTreeButton
                  active={showOrgTree}
                  onClick={() =>
                    this.props.fetchTransactionsFilters({
                      showOrgTree: !showOrgTree,
                    })
                  }
                />
                <SummaryButton
                  size="medium"
                  disabled={!hasSelection}
                  onClick={() =>
                    this.props.setTransactionsView({
                      showSummary: !showSummary,
                    })
                  }
                  active={showSummary}
                />
                <DownloadButton
                  size="medium"
                  disabled={!hasSelection}
                  loading={exportLoading}
                  onClick={this.loadExport}
                />
              </div>
              <div className="flex-stretch ml-1">
                <TransactionFilters refresh={this.onRefresh} />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column width="16" className="gs-flex-container-vertical">
            <Tab
              renderActiveOnly={false}
              panes={panes}
              className="flex-stretch gs-flex-container-vertical height-100"
              onTabChange={this.onTabChange}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.transactionsFilters,
    kiosk: state.transactionsKiosk,
    tickets: state.transactionsTickets,
    liability: state.transactionsLiability,
    view: state.transactionsView,
  };
};

export default connect(mapStateToProps, {
  fetchTransactionsFilters,
  emptyTransactionsSection,
  setTransactionsTickets,
  setTransactionsLiability,
  setTransactionsView,
  setTransactionsKiosk,
})(TransactionsView);
